export const baseURL=process.env.NODE_ENV==='development'?'http://localhost:4001':'https://skgrocery-server.vercel.app'